export default __webpack_public_path__ + "public/logo_blanc.png";